import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { PosTerminal } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useGetTerminals = () => {
  const branchId = useBranchId();

  const query = useQuery<PosTerminal[]>({
    queryKey: ["pos-terminals", branchId],
    queryFn: () =>
      get2(`internal/secure/pos/v1/paynl/pos-terminals/${branchId}`),
    enabled: branchId !== -1,
    refetchOnWindowFocus: false,
  });

  return query;
};

export default useGetTerminals;
